/**
 * Hard reload bypassing browser cache — equivalent to Ctrl+Shift+R.
 * location.reload(true) is deprecated and ignored by modern browsers,
 * so we clear every cache layer manually before reloading.
 */
export async function hardRefresh(): Promise<void> {
  try {
    if ("caches" in window) {
      const keys = await window.caches.keys();
      await Promise.all(keys.map((key) => window.caches.delete(key)));
    }
    if ("serviceWorker" in navigator) {
      const registrations = await navigator.serviceWorker.getRegistrations();
      await Promise.all(registrations.map((r) => r.unregister()));
    }
    // Refetch the document from the network so the cached HTML entry
    // (and with it the hashed asset URLs) is replaced before reload.
    await fetch(window.location.href, { cache: "reload", credentials: "same-origin" });
  } catch {
    // Cache cleanup is best-effort — reload regardless.
  }
  window.location.reload();
}
